// extracted by mini-css-extract-plugin
export default {"contactSelect":"contactCard_contactSelect__G2aa3"};